module.exports = __webpack_public_path__ + "img/avantage-commerce-local.1c8f843a.svg";